/* Kokybės klasės iššokantis langelis.
 *
 * Vienas dialogas visam puslapiui, kuriamas tik pirmą kartą paspaudus. Turinys imamas iš
 * ženklo data-* atributų, todėl jokių tekstų čia nėra — viskas ateina iš metaobjektų
 * vertimų per Liquid.
 *
 * Klausytojas yra DELEGUOTAS ant document: kortelės kolekcijoje kraunamos ir keičiamos
 * dinamiškai (filtrai, begalinis slinkimas), o deleguotas klausytojas veikia ir naujai
 * atsiradusiems ženklams.
 */
(function () {
  'use strict';

  var dlg = null;
  var grazinti = null;   // elementas, į kurį grąžinamas fokusas

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function sukurk() {
    var back = el('div', 'qc-modal', null);
    back.setAttribute('hidden', '');
    var box = el('div', 'qc-modal__box');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('tabindex', '-1');

    var close = el('button', 'qc-modal__close');
    close.type = 'button';
    close.innerHTML = '&times;';

    var badge = el('span', 'quality-class-badge qc-modal__badge');
    var short = el('p', 'qc-modal__short');
    var full = el('p', 'qc-modal__full');
    var warr = el('p', 'qc-modal__warranty');
    var links = el('p', 'qc-modal__links');

    box.appendChild(close);
    box.appendChild(badge);
    box.appendChild(short);
    box.appendChild(full);
    box.appendChild(warr);
    box.appendChild(links);
    back.appendChild(box);
    document.body.appendChild(back);

    back.addEventListener('click', function (e) {
      if (e.target === back) uzdaryk();
    });
    close.addEventListener('click', uzdaryk);

    dlg = {back: back, box: box, close: close, badge: badge,
           short: short, full: full, warr: warr, links: links};
    return dlg;
  }

  function uzdaryk() {
    if (!dlg || dlg.back.hasAttribute('hidden')) return;
    dlg.back.setAttribute('hidden', '');
    document.documentElement.classList.remove('qc-modal-open');
    if (grazinti && document.contains(grazinti)) {
      grazinti.focus();          // fokusas grįžta į tą patį ženklą
    }
    grazinti = null;
  }

  function atidaryk(btn) {
    var d = dlg || sukurk();
    var g = function (n) { return btn.getAttribute('data-qc-' + n) || ''; };

    d.badge.textContent = g('name');
    d.badge.style.setProperty('--qc-bg', g('bg'));
    d.badge.style.setProperty('--qc-fg', g('fg'));
    d.short.textContent = g('short');
    d.short.hidden = !g('short');
    d.full.textContent = g('full');
    d.full.hidden = !g('full');

    d.close.setAttribute('aria-label', g('close'));
    d.box.setAttribute('aria-label', g('name'));

    // PRO+ garantijos eilutė ir nuoroda — tik jei ženklas jas turi
    var w = g('warranty');
    d.warr.textContent = w;
    d.warr.hidden = !w;

    d.links.innerHTML = '';
    if (g('link')) {
      var a = el('a', 'qc-modal__link', g('link-label'));
      a.href = g('link');
      d.links.appendChild(a);
    }
    if (g('warranty-url')) {
      if (d.links.childNodes.length) d.links.appendChild(document.createTextNode(' · '));
      var a2 = el('a', 'qc-modal__link', g('warranty-label'));
      a2.href = g('warranty-url');
      d.links.appendChild(a2);
    }

    grazinti = btn;
    d.back.removeAttribute('hidden');
    document.documentElement.classList.add('qc-modal-open');
    d.box.focus();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-quality-class') : null;
    if (!btn) return;
    // Kortelėje ženklas guli ant prekės nuorodos — sustabdom, kad neatidarytų prekės.
    e.preventDefault();
    e.stopPropagation();
    atidaryk(btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') uzdaryk();
  });
})();
